<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="17"
    viewBox="0 0 24 17"
  >
    <g
      id="Group_889"
      data-name="Group 889"
      transform="translate(-67.281 -293.146)"
    >
      <path
        id="Subtraction_6"
        data-name="Subtraction 6"
        d="M21.428,17H2.568A2.56,2.56,0,0,1,0,14.452V2.547A2.561,2.561,0,0,1,2.568,0H21.428A2.563,2.563,0,0,1,24,2.547V14.452A2.562,2.562,0,0,1,21.428,17ZM9.428,4.25V13.6l6.855-4.678L9.428,4.25Z"
        transform="translate(67.281 293.146)"
        fill="#bbb"
      />
    </g>
  </svg>
</template>
<script setup lang="ts">
import IconProps from '@/assets/ts/interfaces/IconProps'

withDefaults( defineProps<IconProps>(), {} )
</script>